<template lang="pug">
  UiModal(
    :value="value"
    @input="$emit('input', $event)"
    :destroy="true"
    :showFooter="false"
    windowClass="questionnaire-modal"
  )
    .questionnaire-question.questionnaire-content
      .questionnaire__header.-margin-xl-
        .questionnaire__title.-margin-m-
          | Ты можешь изменить курс
        .questionnaire__description
          | Ты можешь выбрать курс из доступных для ученика
      p.questionnaire-content__title Выбери курс
      .questionnaire-question-grid.-one-.questionnaire__limiter
        UiButton.-blue-gray-(
          :class="{'-active-': this.selectedCourse === 'speed'}"
          @click="setCourse('speed')"
        ) Скорость
        UiButton.-blue-gray-(
          :class="{'-active-': this.selectedCourse === 'hundred'}"
          @click="setCourse('hundred')"
        ) Сотка
      UiButton(
        :disabled="!selectedCourse"
        @click="showConfirmModal"
      ) Сохранить
    UiModal(
      v-model="isConfirmModalOpen"
      :bodyClass="!changedCourse && '-left-'"
      acceptText="Подтвердить"
      rejectText="Закрыть"
      acceptColor="primary"
      rejectColor="blue-gray"
      acceptClass="-smart- questionnaire-modal__button -min-"
      rejectClass="-smart- questionnaire-modal__button -min-"

      :destroy="true"

      :showFooter="!changedCourse"

      :reverse="true"
      :loadingAccept="sendingCourse"

      @accept="sendCourse"
      @reject="unshowConfirmModal"

    )
      template(
        v-if="!changedCourse"
      )
        .ui-kit-modal__title
          | Ты действительно хочешь изменить курс участника?
        p
          | Если ты сменишь курс, участник больше не сможет
          |  просматривать предыдущий курс.
      template(
        v-else
      )
        .questionnaire-modal-content.-center-
          .ui-kit-modal__title
            | Ты успешно изменил курс!
          ComputerImg
          UiButton.questionnaire-modal-content__button(
            @click="unshowConfirmModal"
          ) Сохранить


</template>

<script>
import ComputerImg from './ComputerImg';
export default {
  components: {
    ComputerImg
  },
  props: {
    value: {},
    userId: {}
  },
  data: () => ({
    recomendedCourse: 'speed',
    selectedCourse: null,
    isConfirmModalOpen: false,
    sendingCourse: false,
    changedCourse: false
  }),
  watch: {
    isConfirmModalOpen(state) {
      if (!state && this.changedCourse) {
        this.clearSuccessData();
        // Сейчас модалка связанна со строкой таблицы
        // 'updateCourse' вызовет удаление строки и модалка исчезнет
        // Так что вызываем обновление только после закрытия
        this.$emit('updateCourse');
      }
    }
  },
  methods: {
    setCourse(course) {
      this.selectedCourse = course;
    },
    async sendCourse() {
      this.sendingCourse = true;
      const res = await this.$store.dispatch('questionnaire/setCourse', {
        course: this.selectedCourse,
        userId: this.userId
      });
      this.sendingCourse = false;

      if (res.status === 'success') {
        this.changedCourse = true;
      }
    },
    showConfirmModal() {
      this.isConfirmModalOpen = true;
    },
    unshowConfirmModal() {
      this.isConfirmModalOpen = false;
    },
    clearSuccessData() {
      this.unshowConfirmModal();
      this.$emit('input', false);
      this.changedCourse = false;
      this.selectedCourse = null;
    }
  }
};
</script>
